export const PercentageDiscount = async (
  product,
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId,
  removeDiscounts
) => {
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const taxIncludeFlag = tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
  let modificationsMade = false; // Flag to indicate modifications

  // Iterate through each item in the cart
  cartObj.items.map((item) => {
    let excludingFlag = true;
    const matchingCategory = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (
      (pricingRule.excludeProductCategories === "Y" && matchingCategory) ||
      (pricingRule.excludeProductCategories !== "Y" && !matchingCategory) ||
      (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === item.productBrandId);
    if (
      (pricingRule.excludeBrands === "Y" && matchingBrand) ||
      (pricingRule.excludeBrands !== "Y" && !matchingBrand) ||
      (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId);
    if (
      (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
      (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1) ||
      (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
    ) {
      excludingFlag = false;
    }

    let pricingRuleFlag = true;

    // Apply additional logic for pricingRuleFlag based on your requirements

    if (item.discount <= 0 && item.mPricingRulesId !== null && item.mPricingRulesId !== undefined) {
      pricingRule.mPricingXProducts.forEach((res) => {
        if (res.mProductId === item.productId) {
          delete item.priority;
        }
      });
    }

    if (
      saleTypeValidation &&
      excludingFlag &&
      pricingRuleFlag &&
      (product.productId === item.productId || iscoupon || removeDiscounts) &&
      (item?.priority ? item?.priority < pricingRule.priority : true)
    ) {
      const offerIndex =
        pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "N"
          ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId)
          : pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "Y"
          ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId !== item.productId)
          : 0;

      // if (offerIndex >= 0 && Math.abs(item.weight) >= pricingRule.minimumQty) {
      //   const discountAmt = ((pricingRule.percentageDiscount / 100) * parseFloat(item.realPrice)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);
      //   const sp = parseFloat(item.realPrice) - discountAmt;
      //   const mrp = parseFloat(sp) * item.weight;
      //   let tax;
      //   if (Array.isArray(item.children) && item.children.length > 0) {
      //     tax = item.children.reduce((sum, child) => sum + (child.taxAmount || 0), 0);
      //   } else {
      //     tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
      //   }
      //   // const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
      //   item.salePrice = sp;
      //   item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      //   item.nettotal =
      //     taxIncludeFlag === "Y"
      //       ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
      //       : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      //   item.discount = parseFloat((discountAmt * item.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      //   item.discountName = pricingRule.printedName;
      //   item.mPricingruleId = pricingRule.mPricingrulesId;
      //   item.nextRule = pricingRule.nextRule;
      //   item.iscoupon = iscoupon;
      //   item.couponInput = couponInput;
      //   item.referenceId = uniqReferenceId;
      //   item.mPricingCouponId = mPricingCouponId;
      //   item.priority = pricingRule.priority;
      //   modificationsMade = true;
      //   // Modifications made for the current item
      // }

      if (offerIndex >= 0 && Math.abs(item.weight) >= pricingRule.minimumQty) {
        const prcPrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

        if (Array.isArray(item.children) && item.children.length > 0) {
          let totalNet = 0;
          let totalTax = 0;
          let totalDiscount = 0;

          item.children.forEach((child) => {
            const discountAmt = ((pricingRule.percentageDiscount / 100) * parseFloat(child.realPrice)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);
            const sp = parseFloat(child.realPrice) - discountAmt;
            const mrp = parseFloat(sp) * child.weight;

            let tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + child.taxRate / 100) : (mrp * child.taxRate) / 100;
            child.salePrice = sp;
            child.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            child.nettotal =
              taxIncludeFlag === "Y"
                ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            child.discount = parseFloat((discountAmt * child.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            child.discountName = pricingRule.printedName;
            child.mPricingruleId = pricingRule.mPricingrulesId;
            child.nextRule = pricingRule.nextRule;
            child.iscoupon = iscoupon;
            child.couponInput = couponInput;
            child.referenceId = uniqReferenceId;
            child.mPricingCouponId = mPricingCouponId;
            child.priority = pricingRule.priority;

            totalNet += child.nettotal;
            totalTax += tax;
            totalDiscount += child.discount;
          });

          // Set sum on parent
          item.nettotal = parseFloat(totalNet.toFixed(prcPrecision));
          item.taxAmount = parseFloat(totalTax.toFixed(prcPrecision));
          item.discount = parseFloat(totalDiscount.toFixed(prcPrecision));
          item.discountName = pricingRule.printedName;

          modificationsMade = true;
        } else {
          // If no children, apply discount to parent
          const discountAmt = ((pricingRule.percentageDiscount / 100) * parseFloat(item.realPrice)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);
          const sp = parseFloat(item.realPrice) - discountAmt;
          const mrp = parseFloat(sp) * item.weight;

          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
          item.salePrice = sp;
          item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          item.nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          item.discount = parseFloat((discountAmt * item.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          item.discountName = pricingRule.printedName;
          item.mPricingruleId = pricingRule.mPricingrulesId;
          item.nextRule = pricingRule.nextRule;
          item.iscoupon = iscoupon;
          item.couponInput = couponInput;
          item.referenceId = uniqReferenceId;
          item.mPricingCouponId = mPricingCouponId;
          item.priority = pricingRule.priority;
          modificationsMade = true;
        }
      } else {
        const mrp = parseFloat(item.realPrice) * item.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
        item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.nettotal =
          taxIncludeFlag === "Y"
            ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
            : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.discount = 0;
        item.discountName = "";
        item.mPricingruleId = null;
        delete item.nextRule;
      }
    }
  });

  if (modificationsMade) {
    // Update the cart object with the adjusted items
    let couponsData = cart.couponInput?.length > 0 ? [...cart.couponInput] : [];
    if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null && mPricingRulesId) {
      couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
    }
    const adjustedCartObj = {
      ...cartObj,
      items: cartObj.items,
      iscoupon: iscoupon,
      couponInput: couponsData,
    };
    setCart(adjustedCartObj);
    localStorage.setItem("cartObj", JSON.stringify(adjustedCartObj));
    return adjustedCartObj;
  }
};
